export enum Tariff {
  BASIC = 'basic',
  STANDARD = 'standard',
  PREMIUM = 'premium'
}
